import { PhoneDto } from '../interfaces/dtos/ContactUsDto';
import { Phone } from '../interfaces/Phone';

export default function transformPhone(dto: PhoneDto): Phone {
  if (dto.number === null) return undefined;
  return {
    extension: dto.extension,
    label: dto.label,
    number: dto.number,
  };
}
